// extracted by mini-css-extract-plugin
module.exports = {"container":"collapse_container__aqKO6","body":"collapse_body__1LY0B"};